import plur from "plur";
import { PaymentMethod } from "../../../../common/enums";

const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  [PaymentMethod.ACH]: "ACH direct deposit",
  [PaymentMethod.EFT]: "EFT Canada bank transfer",
  [PaymentMethod.SEPA]: "SEPA Europe bank transfer",
  [PaymentMethod.Wire]: "Wire transfer",
  [PaymentMethod.Check]: "Check",
  [PaymentMethod.BACS]: "UK bank transfer (BACS/FPS/CHAPS)",
  [PaymentMethod.BECS]: "Australia direct entry (BECS)",
  [PaymentMethod.Other]: "Other",
};

export const getPaymentMethodText = (paymentMethod: PaymentMethod): string => {
  return PAYMENT_METHOD_LABELS[paymentMethod];
};

export const getToastSuccessMessage = ({
  positionsCount,
  accountsCount,
  paymentMethod,
  requiresStaffApproval = false,
}: {
  positionsCount: number;
  accountsCount: number;
  paymentMethod?: PaymentMethod;
  requiresStaffApproval?: boolean;
}): string => {
  const paymentPrefLabel = paymentMethod ? getPaymentMethodText(paymentMethod) : "The";
  const plurInvestment = plur("investment", positionsCount);
  const plurAccount = plur("account", accountsCount);
  const baseMessage = `${paymentPrefLabel} payment method applied to ${positionsCount} ${plurInvestment} in ${accountsCount} investment ${plurAccount}.`;
  return requiresStaffApproval
    ? `${baseMessage} Some changes may require manager approval.`
    : baseMessage;
};

export const getSummaryDescription = ({
  positionsCount,
  accountsCount,
}: {
  positionsCount: number;
  accountsCount: number;
}): string => {
  return `This payment method will be applied to ${positionsCount} ${plur(
    "investment",
    positionsCount,
  )} in ${accountsCount} investment ${plur("account", accountsCount)}.`;
};
